import { render, staticRenderFns } from "./ProductionItem_v2.vue?vue&type=template&id=29c7d1ac"
import script from "./ProductionItem_v2.vue?vue&type=script&lang=js"
export * from "./ProductionItem_v2.vue?vue&type=script&lang=js"
import style0 from "./ProductionItem_v2.vue?vue&type=style&index=0&id=29c7d1ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports